import { createSelector } from 'reselect';
import { getTrolley } from './get-items';

const EMPTY_OBJECT = {};

export const getSwapUnavailableProductModal = createSelector(
  getTrolley,
  trolley => trolley?.swapUnavailableProductModal ?? EMPTY_OBJECT,
);
